module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idgenobjectstyleoverride",
    attrs: {
      "id": "_idContainer1347"
    }
  }, [_c('p', {
    staticClass: "content-chapter1",
    attrs: {
      "id": "calibre_toc_3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_006#_idTextAnchor018"
    }
  }, [_vm._v("Shopping Tips"), _c('span', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _c('span', {
    staticClass: "bold2"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body_heading"
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("How to Navigate the Grocery Store Like a Boss")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("This book is loaded with shopping tips that will change the way you navigate the grocery store. Here are some general shopping guidelines before you get into recipes and detailed grocery tips. Keep in mind, I have hundreds of grocery haul videos on YouTube, including hauls from Costco, ALDI, Trader Joe’s, Whole Foods, Walmart and more! If you ever have a question, search “FlavCity + XYZ” o"), _c('span', [_vm._v("n")]), _c('span'), _c('span', [_vm._v("YouTube.")])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_22"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2feb186d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/5Ingredient_split_011.vue
// module id = 90
// module chunks = 0